import SelectionState from "state/selections/SelectionState";
import scope from "./scope";
import {
  fetchAttributeDescriptions,
  fetchEntityAttributes,
} from "@ls/entity-service";
import { selectBaseGroupingParams } from "state/selections/selector";
import { exchange } from "@ls/js-fetch";
import { selectDefinitions } from "./selectors";

export const SET_DEFINITION = `${scope}/SET_DEFINITION`;
export const setDefinition = (idx, definition) => ({
  type: SET_DEFINITION,
  idx,
  definition,
});

export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (definitions) => ({
  type: SET_DEFINITIONS,
  definitions,
});

export const REQUEST_ATTRIBUTE_VALUES = `${scope}/REQUEST_ATTRIBUTE_VALUES`;
export const RECEIVE_ATTRIBUTE_VALUES = `${scope}/RECEIVE_ATTRIBUTE_VALUES`;
export const requestAttributeValues = () => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_ATTRIBUTE_VALUES });
    dispatch({
      type: RECEIVE_ATTRIBUTE_VALUES,
      data: await fetchAttributeDescriptions(),
    });
  };
};

export const REQUEST_ATTRIBUTE_DATA = `${scope}/REQUEST_ATTRIBUTE_DATA`;
export const RECEIVE_ATTRIBUTE_DATA = `${scope}/RECEIVE_ATTRIBUTE_DATA`;
export const requestAttributeData = () => {
  return async (dispatch, getState) => {
    const state = getState();
    dispatch({ type: REQUEST_ATTRIBUTE_DATA });
    const [baseParams] = selectBaseGroupingParams(state);
    const definitions = selectDefinitions(SelectionState.COMMITTED)(state);
    const params = {
      ...baseParams,
      analytics: "NONE",
      meta_data: "ATTRIBUTES",
      entity_attributes: definitions.reduce(
        (arr, def) => {
          if (def.attribute === "name" || def.attribute === "benchmarkName") {
            arr.push("longName");
          }
          arr.push(def.attribute);
          return arr;
        },
        ["benchmarkId", "type"]
      ), //always request these
    };
    const url = process.env.REACT_APP_BASE_URL_GROUPING_SERVICE;

    dispatch({
      type: RECEIVE_ATTRIBUTE_DATA,
      data: (
        await exchange({
          params: params,
          url,
          cancelId: `attrib-data`,
        })
      )?.data,
    });
  };
};

export const REQUEST_ENTITY_ATTRIBUTES = `${scope}/REQUEST_ENTITY_ATTRIBUTES`;
export const RECEIVE_ENTITY_ATTRIBUTES = `${scope}/RECEIVE_ENTITY_ATTRIBUTES`;
export const requestEntityAttributes = (asOfDate) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_ENTITY_ATTRIBUTES });
    dispatch({
      type: RECEIVE_ENTITY_ATTRIBUTES,
      data: await fetchEntityAttributes({ entityDates: asOfDate }),
    });
  };
};
